import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../utils";
import { Icon } from "../Icon";

export const tokenIconSymbols = ["btc", "eth", "arb", "usdc"] as const;

export const tokenIconSizes = ["xs", "sm", "md", "lg", "xl"] as const;

export type TokenIconSize = (typeof tokenIconSizes)[number];

export type TokenIconSymbol = (typeof tokenIconSymbols)[number];

export interface TokenIconProps extends HTMLAttributes<HTMLElement> {
  ref?: Ref<HTMLElement>;
  size?: TokenIconSize;
  fill?: boolean;
  symbol: TokenIconSymbol;
  rounded?: boolean;
  outline?: boolean;
  gradient?: boolean;
}

export const TokenIcon = ({
  size = "md",
  fill = false,
  symbol,
  rounded = true,
  outline = false,
  gradient = false,
  className,
  onClick,
  ref,
  ...props
}: TokenIconProps) => {
  return (
    <Icon
      ref={ref}
      name={symbol}
      className={cn(
        "ui:flex ui:aspect-square ui:items-center ui:justify-center ui:transition-colors",
        {
          "ui:bg-buttonFill": fill,
          "ui:rounded-full": rounded,
          "ui:rounded-xs": !rounded,
          "ui:border ui:border-divider": outline,
          "ui:token-icon-gradient-text ui:rounded-[5px] ui:border-[0.6px] ui:border-white/10 ui:bg-[linear-gradient(180deg,#FFF_0%,#EFEFEF_100%)] ui:shadow-[0px_0px_4px_0px_rgba(81,81,81,0.15)_inset] ui:dark:bg-[linear-gradient(180deg,rgba(23,23,23,0.50)_0%,#1D1D1D_100%)] ui:dark:shadow-[0px_0px_6.3px_0px_rgba(81,81,81,0.50)_inset]":
            gradient,
          "ui:cursor-pointer": Boolean(onClick),
          "ui:hover:text-textPrimary": Boolean(onClick),
        },
        {
          "ui:size-4 ui:text-xs": size === "xs",
          "ui:size-6": size === "sm",
          "ui:size-8 ui:text-xl": size === "md",
          "ui:size-10 ui:text-2xl": size === "lg",
          "ui:size-12 ui:text-3xl": size === "xl",
          "ui:text-sm": gradient,
        },
        className,
      )}
      onClick={onClick}
      {...props}
    />
  );
};
